import { render, staticRenderFns } from "./Vehicles.vue?vue&type=template&id=72db3006&"
import script from "./Vehicles.vue?vue&type=script&lang=ts&"
export * from "./Vehicles.vue?vue&type=script&lang=ts&"
import style0 from "./Vehicles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports